var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('div',{staticClass:"image-modal",on:{"click":function($event){return _vm.close()}}},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":"Static Image"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }